// Anita Week 9 / Day 1 — User Mode or Creator Mode.
// Verbatim from FINAL Week 9 Part A (Creator) source-of-truth package.
// Staged on disk; Week 9 remains a locked placeholder until Days 4–5 are authored.

const day1 = {
  id: 'day-1',
  studentId: 'anita',
  weekId: 'week-9',
  dayId: 'day-1',
  status: 'active',
  title: 'Режим зрителя или Режим автора / User Mode or Creator Mode',
  shortTitle: 'Зритель → Автор / User → Creator',
  theme: 'Анита учится отличать режим зрителя от режима автора и понимать, что полезное действие начинается с выбора. / Anita learns the difference between user mode and creator mode and understands that useful action starts with a choice.',
  estimatedTimeLabel: '60–90 минут / 60–90 minutes',
  lessonTiming: { minMinutes: 60, maxMinutes: 90, breaks: 2 },
  bilingualMode: 'ru-primary-en-helper',
  readingLevel: 'grade-2',
  courseLayers: ['reading', 'math', 'creator-mindset', 'attention', 'sorting', 'spelling', 'creative', 'speech'],
  nimnyIntro:
    'Нимни показывает Аните волшебный переключатель: ЗРИТЕЛЬ → АВТОР. В режиме зрителя человек только смотрит и листает. В режиме автора человек думает, выбирает, объясняет и делает что-то полезное. Сегодня Анита узнает: я могу не только смотреть — я могу создавать. / Nimny shows Anita a magic switch: USER → CREATOR. In user mode, a person only watches and scrolls. In creator mode, a person thinks, chooses, explains and makes something useful. Today Anita learns: I can do more than watch — I can create.',
  goals: [
    'Понять слова user, creator, смотреть, создавать, польза. / Understand user, creator, watch, create, benefit.',
    'Отличать действия пользователя от действий автора. / Tell user actions from creator actions.',
    'Понять, что автор делает полезный результат. / Understand that a creator makes a useful result.',
    'Решать задачи на карточки, группы, умножение и деление. / Solve card, group, multiplication and division tasks.',
    'Сделать переключатель ЗРИТЕЛЬ → АВТОР. / Make a User → Creator switch.',
    'Сказать родителю фразу автора. / Say a creator phrase to parent.'
  ],
  vocabulary: [
    { term: 'пользователь / user', definition: 'человек, который смотрит, слушает или использует. / a person who watches, listens or uses.' },
    { term: 'автор / creator', definition: 'человек, который делает что-то полезное или понятное. / a person who makes something useful or clear.' },
    { term: 'создавать / create', definition: 'делать новый полезный результат. / make a new useful result.' },
    { term: 'польза / benefit', definition: 'чем вещь или идея помогает. / how a thing or idea helps.' },
    { term: 'выбор / choice', definition: 'когда ты решаешь, что делать. / when you decide what to do.' },
    { term: 'внимание / attention', definition: 'сила ума смотреть и думать о чём-то. / the mind power to look and think.' },
    { term: 'пауза / pause', definition: 'остановиться и подумать. / stop and think.' },
    { term: 'идея / idea', definition: 'мысль о том, что можно сделать. / a thought about what to do.' },
    { term: 'результат / result', definition: 'что получилось после действий. / what came out after actions.' },
    { term: 'объяснить / explain', definition: 'сделать понятным для другого. / make it clear for another person.' }
  ],
  onlineTasks: [
    { id: 'reading-words', type: 'text', title: 'Задание 1 — Слова автора / Creator Words',
      prompt: 'Прочитай по-русски:\n\nпользователь\nавтор\nсоздавать\nпольза\nвыбор\nвнимание\nпауза\nидея\nрезультат\nобъяснить',
      ruPrimaryText: 'Прочитай 10 русских слов автора.',
      enHelpText: 'Read the Russian creator words first. English is only for help.',
      answer: 'Attempted Russian reading.' },
    { id: 'reading-sentences', type: 'text', title: 'Задание 2 — Маленькое чтение / Short Reading',
      prompt: 'Прочитай по-русски:\n\nЯ могу не только смотреть.\nЯ могу сделать полезную памятку.\nАвтор думает, выбирает и объясняет.\nМой результат может помочь другому человеку.',
      ruPrimaryText: 'Прочитай 4 короткие фразы автора.',
      enHelpText: 'I can do more than watch. I can create a useful card. A creator thinks, chooses and explains. My result can help another person.',
      answer: 'Attempted Russian reading.' },
    { id: 'user-creator-sort', type: 'classify', title: 'Задание 3 — User или Creator? / User or Creator?',
      prompt: 'Разложи 15 карточек по трём категориям.\n\nКатегории:\n1. Режим зрителя — только смотрю или потребляю.\n2. Режим автора — создаю полезный результат.\n3. Both / зависит от цели — может быть и так, и так.\n\nКарточки:\n1. Смотреть ролики без цели.\n2. Нарисовать инструкцию «как попросить помощи».\n3. Листать ленту, забыв про время.\n4. Сделать мини-гайд «как проверить рекламу».\n5. Повторить чужую идею без понимания.\n6. Объяснить младшему ребёнку правило безопасности.\n7. Смотреть урок и делать заметки.\n8. Сделать карточку «стоп — уйти — рассказать».\n9. Прочитать ответ и проверить с родителем.\n10. Снять видео без разрешения родителя.\n11. Нарисовать схему «как измерить предмет».\n12. Просто нажимать на яркие картинки.\n13. Сделать постер «не вводи пароль».\n14. Смотреть мультфильм после всех дел.\n15. Сделать черновик полезной идеи.',
      ruPrimaryText: 'Разложи 15 карточек: Режим зрителя / Режим автора / Both.',
      enHelpText: 'Sort 15 cards into User Mode, Creator Mode or Both/depends.',
      categories: [
        { id: 'user', label: 'Режим зрителя — только смотрю или потребляю / User Mode' },
        { id: 'creator', label: 'Режим автора — создаю полезный результат / Creator Mode' },
        { id: 'both', label: 'Both / зависит от цели / Both, depends on purpose' }
      ],
      items: [
        { id: 'c1', label: '1. Смотреть ролики без цели.', category: 'user' },
        { id: 'c2', label: '2. Нарисовать инструкцию «как попросить помощи».', category: 'creator' },
        { id: 'c3', label: '3. Листать ленту, забыв про время.', category: 'user' },
        { id: 'c4', label: '4. Сделать мини-гайд «как проверить рекламу».', category: 'creator' },
        { id: 'c5', label: '5. Повторить чужую идею без понимания.', category: 'user' },
        { id: 'c6', label: '6. Объяснить младшему ребёнку правило безопасности.', category: 'creator' },
        { id: 'c7', label: '7. Смотреть урок и делать заметки.', category: 'both' },
        { id: 'c8', label: '8. Сделать карточку «стоп — уйти — рассказать».', category: 'creator' },
        { id: 'c9', label: '9. Прочитать ответ и проверить с родителем.', category: 'both' },
        { id: 'c10', label: '10. Снять видео без разрешения родителя.', category: 'user' },
        { id: 'c11', label: '11. Нарисовать схему «как измерить предмет».', category: 'creator' },
        { id: 'c12', label: '12. Просто нажимать на яркие картинки.', category: 'user' },
        { id: 'c13', label: '13. Сделать постер «не вводи пароль».', category: 'creator' },
        { id: 'c14', label: '14. Смотреть мультфильм после всех дел.', category: 'both' },
        { id: 'c15', label: '15. Сделать черновик полезной идеи.', category: 'creator' }
      ],
      answer: 'User: 1, 3, 5, 12 (and 10 — parent discusses as unsafe without permission). Creator: 2, 4, 6, 8, 11, 13, 15. Both: 7, 9, 14.' },
    { id: 'math-mode-cards', type: 'text', title: 'Задание 4 — Считаем режимы / Count the Modes',
      prompt: 'У Нимни 18 карточек действий.\n\n6 карточек — Режим зрителя.\n8 карточек — Режим автора.\n4 карточки — Both / зависит от цели.\n\nОтветь:\n1. Сколько всего карточек?\n2. Сколько карточек НЕ только Режим зрителя?\n3. Во сколько раз Режим автора больше, чем Both?\n4. Если добавить ещё 4 карточки в Режим автора, сколько их станет?',
      ruPrimaryText: 'Реши 4 задачи про 18 карточек режимов.',
      enHelpText: 'Solve 4 problems about 18 mode cards.',
      answer: '1) 6 + 8 + 4 = 18. 2) 8 + 4 = 12. 3) 8 ÷ 4 = 2. 4) 8 + 4 = 12.' },
    { id: 'math-creator-time', type: 'text', title: 'Задание 5 — Время автора / Creator Time',
      prompt: 'Анита делает полезную памятку.\n\nПлан:\n1. Идея — 6 минут.\n2. Черновик — 6 минут.\n3. Рисунок — 6 минут.\n4. Проверка — 6 минут.\n5. Объяснение родителю — 6 минут.\n\nОтветь:\n1. Сколько всего минут, если 5 шагов по 6 минут?\n2. Если Анита сделала 2 шага, сколько минут уже прошло?\n3. Сколько шагов осталось?\n4. Если у неё есть 40 минут, сколько минут останется после проекта?',
      ruPrimaryText: 'Реши 4 задачи про время автора.',
      enHelpText: 'Solve 4 creator-time problems.',
      answer: '1) 5 × 6 = 30 минут. 2) 2 × 6 = 12 минут. 3) 5 − 2 = 3 шага. 4) 40 − 30 = 10 минут.' },
    { id: 'mini-creator-graph', type: 'text', title: 'Задание 6 — Мини-график действий / Mini Action Graph',
      prompt: 'Нимни записала действия за день:\n\nсмотреть — 5\nчитать — 3\nсоздавать — 4\nобъяснять — 2\n\nНарисуй мини-график квадратиками или в тетради:\n\nсмотреть: □ □ □ □ □\nчитать: □ □ □\nсоздавать: □ □ □ □\nобъяснять: □ □\n\nОтветь:\n1. Какое действие было чаще всего?\n2. На сколько «создавать» меньше, чем «смотреть»?\n3. Сколько всего полезных действий: читать + создавать + объяснять?',
      ruPrimaryText: 'Нарисуй мини-график и реши 3 задачи.',
      enHelpText: 'Draw the mini graph and answer 3 questions.',
      answer: '1) Смотреть. 2) 5 − 4 = 1. 3) 3 + 4 + 2 = 9.' },
    { id: 'spelling-creator', type: 'text', title: 'Задание 7 — Правописание / Spelling',
      prompt: 'Напиши:\n\nидея\nпольза\nвыбор\nпауза\nрезультат\n\nВставь буквы:\n\nид_я\nп_льза\nвыб_р\nпа_за\nрез_льтат',
      ruPrimaryText: 'Напиши 5 слов и вставь пропущенные буквы.',
      enHelpText: 'Write 5 words and fill in the missing letters.',
      answer: 'идея, польза, выбор, пауза, результат.' },
    { id: 'creative-user-creator-switch', type: 'text', title: 'Задание 8 — Переключатель ЗРИТЕЛЬ → АВТОР / User → Creator Switch',
      prompt: 'Нарисуй переключатель:\n\nЗРИТЕЛЬ → АВТОР\n\nСлева нарисуй одно действие пользователя.\nСправа нарисуй одно действие автора.\n\nПодпиши:\n\nЯ могу не только смотреть.\nЯ могу создавать полезное.',
      ruPrimaryText: 'Нарисуй переключатель ЗРИТЕЛЬ → АВТОР и подпиши две фразы.',
      enHelpText: 'Draw the ЗРИТЕЛЬ → АВТОР switch and write both phrases.',
      answer: 'Open-ended. Accept if Anita draws both modes and writes or traces the creator phrase.' },
    { id: 'creator-choice-card', type: 'text', title: 'Задание 9 — Мой выбор автора / My Creator Choice',
      prompt: 'Выбери одну полезную маленькую идею:\n\nA. Карточка «как попросить помощи».\nB. Постер «не вводи пароль».\nC. Схема «как измерить предмет».\nD. Мини-гайд «стоп — уйти — рассказать».\n\nЗаполни:\nМоя идея: ______.\nКому поможет: ______.\nПочему полезно: ______.',
      ruPrimaryText: 'Выбери идею и заполни 3 поля: идея, кому поможет, почему полезно.',
      enHelpText: 'Pick one safe useful idea and fill in the 3 fields.',
      answer: 'Open-ended. Accept if Anita chooses one safe useful idea and explains benefit.' },
    { id: 'speech-creator-phrase', type: 'text', title: 'Задание 10 — Объясни родителю / Explain to Parent',
      prompt: 'Скажи родителю по-русски:\n\nЯ могу не только смотреть.\nЯ могу сделать полезную памятку.\nАвтор думает, объясняет и помогает.',
      ruPrimaryText: 'Скажи родителю 3 фразы автора по-русски.',
      enHelpText: 'Say the 3 creator phrases to the parent in Russian.',
      answer: 'Accept if Anita says the creator phrase with support.' }
  ],
  notebookInstructions: [
    'Если нет принтера:',
    '1. Напиши слова дня.',
    '2. Прочитай 4 фразы.',
    '3. Разложи 10 карточек User/Creator/Both устно с родителем.',
    '4. Реши задачи про 18 карточек и 5 шагов по 6 минут.',
    '5. Нарисуй мини-график действий.',
    '6. Нарисуй переключатель ЗРИТЕЛЬ → АВТОР.',
    '7. Выбери одну полезную идею.',
    '8. Скажи родителю фразу автора.'
  ],
  printWorksheet: {
    title: 'Режим зрителя или Режим автора / User Mode or Creator Mode',
    subtitle: 'Неделя 9 · День 1 / Week 9 · Day 1',
    pages: [
      { title: 'Маршрут дня / Route',
        blocks: [
          { type: 'text', text: 'Имя: __________________________   Дата: __________________________' },
          { type: 'text', text: 'Миссия: Нимни показывает переключатель ЗРИТЕЛЬ → АВТОР. Сегодня ты учишься не только смотреть, но и создавать полезное.' },
          { type: 'text', text: 'Задание 1 — Слова автора. Прочитай и обведи:' },
          { type: 'list', items: [
            'пользователь / user',
            'автор / creator',
            'создавать / create',
            'польза / benefit',
            'выбор / choice',
            'внимание / attention',
            'пауза / pause',
            'идея / idea',
            'результат / result',
            'объяснить / explain'
          ] },
          { type: 'text', text: 'Задание 2 — Маленькое чтение. Поставь галочку после чтения:' },
          { type: 'list', items: [
            '□ Я могу не только смотреть.',
            '□ Я могу сделать полезную памятку.',
            '□ Автор думает, выбирает и объясняет.',
            '□ Мой результат может помочь другому человеку.'
          ] },
          { type: 'text', text: 'English help: I can do more than watch. I can create something useful.' }
        ] },
      { title: 'Карточки и математика / Cards and Math',
        blocks: [
          { type: 'text', text: 'Задание 3 — User или Creator? Напиши U, C или B рядом с каждой карточкой: U = Режим зрителя, C = Режим автора, B = Both / зависит от цели.' },
          { type: 'list', items: [
            '1. Смотреть ролики без цели. ____',
            '2. Нарисовать инструкцию «как попросить помощи». ____',
            '3. Листать ленту, забыв про время. ____',
            '4. Сделать мини-гайд «как проверить рекламу». ____',
            '5. Смотреть урок и делать заметки. ____',
            '6. Объяснить младшему ребёнку правило безопасности. ____',
            '7. Сделать карточку «стоп — уйти — рассказать». ____',
            '8. Просто нажимать на яркие картинки. ____',
            '9. Нарисовать схему «как измерить предмет». ____',
            '10. Сделать черновик полезной идеи. ____'
          ] },
          { type: 'text', text: 'Задание 4 — Считаем режимы. 6 карточек — Режим зрителя. 8 карточек — Режим автора. 4 карточки — Both.' },
          { type: 'list', items: [
            '1. Всего карточек: 6 + 8 + 4 = ______',
            '2. НЕ только User: 8 + 4 = ______',
            '3. Creator в сколько раз больше Both: 8 ÷ 4 = ______',
            '4. Если добавить 4 Карточки автора: 8 + 4 = ______'
          ] },
          { type: 'text', text: 'Задание 5 — Время автора. 5 шагов по 6 минут:' },
          { type: 'list', items: [
            '5 × 6 = ______ минут',
            '2 шага уже сделаны: 2 × 6 = ______ минут',
            'Осталось шагов: 5 − 2 = ______',
            'Если есть 40 минут: 40 − 30 = ______ минут осталось'
          ] }
        ] },
      { title: 'Переключатель автора / Creator Switch',
        blocks: [
          { type: 'text', text: 'Задание 6 — Мини-график действий.' },
          { type: 'list', items: [
            'смотреть: □ □ □ □ □',
            'читать: □ □ □',
            'создавать: □ □ □ □',
            'объяснять: □ □'
          ] },
          { type: 'list', items: [
            '1. Чаще всего: ____________________',
            '2. Создавать меньше, чем смотреть, на: ______',
            '3. Читать + создавать + объяснять = ______'
          ] },
          { type: 'text', text: 'Задание 7 — Правописание. Напиши и вставь буквы:' },
          { type: 'list', items: ['идея   польза   выбор   пауза   результат', 'ид_я   п_льза   выб_р   па_за   рез_льтат'] },
          { type: 'text', text: 'Задание 8 — Переключатель ЗРИТЕЛЬ → АВТОР. Нарисуй:' },
          { type: 'list', items: [
            'ЗРИТЕЛЬ → АВТОР',
            'Слева: действие пользователя.',
            'Справа: действие автора.',
            'Фраза: Я могу не только смотреть. ____________________',
            'Фраза: Я могу создавать полезное. ____________________'
          ] },
          { type: 'text', text: 'Задание 9 — Мой выбор автора.' },
          { type: 'list', items: [
            'Моя идея: ____________________',
            'Кому поможет: ____________________',
            'Почему полезно: ____________________'
          ] },
          { type: 'text', text: 'Задание 10 — Объясни родителю. Поставь галочку:' },
          { type: 'list', items: [
            '□ Я могу не только смотреть.',
            '□ Я могу сделать полезную памятку.',
            '□ Автор думает, объясняет и помогает.'
          ] },
          { type: 'text', text: 'Parent Check: □ Прочитала слова  □ Прочитала 4 фразы  □ Разложила карточки  □ Решила математику  □ Нарисовала ЗРИТЕЛЬ → АВТОР  □ Объяснила идею родителю.' },
          { type: 'text', text: 'Notebook Mode — если нет принтера, сделай эти задания в тетради.' }
        ] }
    ]
  },
  parentGuide: {
    goal: 'Анита понимает разницу между режимом пользователя и режимом автора.',
    mathGoal: 'Сложение, вычитание, умножение 5 × 6, деление 8 ÷ 4, таблица действий, мини-график.',
    russianGoal: 'Прочитать слова пользователь, автор, создавать, польза, выбор, внимание, пауза, идея, результат, объяснить.',
    readingWritingGoal: 'Прочитать 4 фразы, написать 5 слов, подписать переключатель ЗРИТЕЛЬ → АВТОР.',
    practicalGoal: 'Выбрать одну безопасную полезную идею и объяснить, кому она поможет.',
    parentTheoryCard: {
      title: 'Как объяснить «пользователь» и «автор»',
      purpose: 'Помочь родителю объяснить, что ребёнок может не только смотреть контент, но и создавать полезный результат.',
      keyMessage: 'Пользователь потребляет. Автор думает, выбирает, объясняет и делает пользу.',
      parentScript: [
        '«User mode — это когда я только смотрю или использую.»',
        '«Creator mode — это когда я делаю что-то полезное: карточку, рисунок, объяснение, план.»',
        '«Автор не обязан делать идеально. Он начинает с маленького черновика.»',
        '«Главный вопрос автора: кому это поможет?»'
      ],
      practiceSteps: [
        'Разберите 5 действий: user или creator.',
        'Попросите Аниту показать переключатель ЗРИТЕЛЬ → АВТОР.',
        'Выберите одну безопасную полезную идею.',
        'Попросите объяснить: кому поможет и почему.'
      ],
      doNotSay: [
        'Не говорить: «Просто перестань смотреть.»',
        'Не стыдить за мультфильмы или ролики.',
        'Не требовать большой проект.',
        'Не просить публиковать онлайн.'
      ],
      paperOnlyNotes: [
        'Все creator products делаются на бумаге или устно дома.',
        'Не публиковать, не загружать, не отправлять незнакомым людям.'
      ]
    },
    whatThisLessonTeaches: 'Анита учится видеть себя не только пользователем, но и авторем полезного.',
    keyMessage: 'Я могу не только смотреть. Я могу создать маленькую полезную вещь.',
    howToExplain: 'Скажите: «Когда ты рисуешь карточку, которая помогает кому-то понять правило, ты уже автор. Не важно, маленький проект или большой.»',
    exampleDialogue:
      'Parent: Если ты просто листаешь картинки, это user или creator?\nChild: User.\nParent: Если ты сделала памятку «как попросить помощи», это кто?\nChild: Creator.\nParent: Почему?\nChild: Потому что это помогает.',
    readingSupport: 'Слова «пользователь», «автор», «объяснить» читать по частям.',
    russianSpeechGoal: 'Анита говорит: «Я могу не только смотреть. Я могу создавать полезное.»',
    mathAnswerKey:
      'math-mode-cards: 1) 18. 2) 12. 3) 2. 4) 12.\nmath-creator-time: 1) 30 минут. 2) 12 минут. 3) 3 шага. 4) 10 минут.\nmini-creator-graph: 1) Смотреть. 2) 1. 3) 9.',
    spellingAnswerKey: 'идея\nпольза\nвыбор\nпауза\nрезультат',
    answerKey: [
      { taskId: 'reading-words', answer: 'Попытка русского чтения.' },
      { taskId: 'reading-sentences', answer: 'Попытка русского чтения.' },
      { taskId: 'user-creator-sort', answer: 'User: 1,3,5,12; Creator: 2,4,6,8,11,13,15; Both: 7,9,14; item 10 discuss as unsafe without parent.' },
      { taskId: 'math-mode-cards', answer: '18; 12; 2; 12.' },
      { taskId: 'math-creator-time', answer: '30; 12; 3; 10.' },
      { taskId: 'mini-creator-graph', answer: 'смотреть; 1; 9.' },
      { taskId: 'spelling-creator', answer: 'идея, польза, выбор, пауза, результат.' },
      { taskId: 'creative-user-creator-switch', answer: 'switch with user and creator actions.' },
      { taskId: 'creator-choice-card', answer: 'safe useful idea with audience and benefit.' },
      { taskId: 'speech-creator-phrase', answer: 'creator phrase spoken.' }
    ],
    check: [
      'Анита прочитала слова и фразы.',
      'Анита отличила user/creator actions.',
      'Анита решила math tasks.',
      'Анита нарисовала переключатель.',
      'Анита выбрала полезную идею.',
      'Анита объяснила родителю.'
    ],
    spellingCheck: 'Проверить идея, польза, выбор, пауза, результат.',
    readingCheck: 'Главное — попытка русского чтения и понимание смысла.',
    practicalCheck: 'Идея должна быть безопасной, семейной, paper-only.',
    drawingCriteria: 'Есть USER side, CREATOR side, фраза и полезная идея.',
    commonMistakes: [
      '«Автор — это только блогер.» Правильно: «Автор — любой, кто создаёт полезное.»',
      '«Нужно публиковать онлайн.» Правильно: «Нет, в курсе создаём на бумаге и показываем родителю.»',
      '«Если черновик некрасивый, это плохо.» Правильно: «Черновик — первый шаг.»'
    ],
    discussionPrompts: [
      'Что ты сегодня делала как user?',
      'Что можно сделать как creator?',
      'Кому поможет твоя карточка?'
    ],
    ifEasy: 'Попросить Аниту придумать 3 creator ideas и выбрать самую полезную.',
    ifDifficult: 'Оставить только две категории: user и creator.',
    rewardGuidance: 'Базовая награда — 3 нима. Бонус за ясную creator phrase или аккуратный переключатель.',
    tokenReward: 'Нимы — это призовые токены курса, а не оплата.',
    parentOnlyNotes: 'Не просить публиковать онлайн. Не использовать реальные аккаунты, фото, имена или личные данные.',
    safetyNotes: 'Все creator products — бумажные или устные, только для семьи/родителя. Никаких публикаций, аккаунтов, фото или контактов с незнакомцами.'
  },
  reward: { unit: 'nim', unitName: 'ним', base: 3, max: 5, label: 'Награда за миссию', display: '3 нима',
    bonuses: [
      { id: 'creator-phrase', label: 'Бонус за ясную фразу «Я могу создавать полезное»', amount: 1 },
      { id: 'neat-switch', label: 'Бонус за аккуратный переключатель ЗРИТЕЛЬ → АВТОР', amount: 1 }
    ] },
  completionRequirements: {
    requiredTaskIds: ['reading-words', 'reading-sentences', 'user-creator-sort', 'math-mode-cards', 'math-creator-time', 'mini-creator-graph', 'spelling-creator', 'creative-user-creator-switch', 'creator-choice-card', 'speech-creator-phrase'],
    allowNotebookCompletion: true
  },
  nextLessonId: 'anita-week-9-day-2'
};

export default day1;
